/**
 * Recently Viewed Products Fix
 * 
 * This script fixes the "Cannot read properties of undefined (reading 'showRecentlyViewed')" 
 * and "Cannot read properties of undefined (reading 'recordRecentlyViewed')" errors
 * by safely initializing the Shopify.Products object if it doesn't exist.
 */

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Recently Viewed Products Fix: Initializing');
    
    // Initialize Shopify object if it doesn't exist
    window.Shopify = window.Shopify || {};
    
    // Initialize Shopify.Products object if it doesn't exist
    window.Shopify.Products = window.Shopify.Products || {};
    
    // Implement safe versions of the recently viewed products functions
    
    // Safe implementation of recordRecentlyViewed
    if (typeof window.Shopify.Products.recordRecentlyViewed !== 'function') {
      window.Shopify.Products.recordRecentlyViewed = function(config) {
        try {
          // Default configuration
          const defaultConfig = {
            handle: null,
            title: null,
            url: null,
            image: null,
            type: null,
            vendor: null,
            price: null
          };
          
          // Merge default config with provided config
          config = Object.assign({}, defaultConfig, config || {});
          
          // Get the current product handle from the page if not provided
          if (!config.handle) {
            const path = window.location.pathname;
            if (path.includes('/products/')) {
              config.handle = path.split('/products/')[1].split('?')[0];
            }
          }
          
          if (!config.handle) {
            console.log('Recently Viewed Products Fix: No product handle found, skipping recordRecentlyViewed');
            return;
          }
          
          // Get existing recently viewed products from localStorage
          let recentlyViewed = [];
          try {
            const stored = localStorage.getItem('recentlyViewed');
            if (stored) {
              recentlyViewed = JSON.parse(stored);
            }
          } catch (e) {
            console.log('Recently Viewed Products Fix: Error reading from localStorage', e);
            recentlyViewed = [];
          }
          
          // Check if this product is already in the list
          const existingIndex = recentlyViewed.findIndex(product => product.handle === config.handle);
          if (existingIndex !== -1) {
            // Remove it so we can add it to the front
            recentlyViewed.splice(existingIndex, 1);
          }
          
          // Add the current product to the front of the list
          recentlyViewed.unshift({
            handle: config.handle,
            title: config.title || document.title,
            url: config.url || window.location.href,
            image: config.image,
            type: config.type,
            vendor: config.vendor,
            price: config.price
          });
          
          // Limit the list to 10 items
          if (recentlyViewed.length > 10) {
            recentlyViewed = recentlyViewed.slice(0, 10);
          }
          
          // Save back to localStorage
          try {
            localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
            console.log('Recently Viewed Products Fix: Successfully recorded product');
          } catch (e) {
            console.log('Recently Viewed Products Fix: Error saving to localStorage', e);
          }
        } catch (e) {
          console.error('Recently Viewed Products Fix: Error in recordRecentlyViewed', e);
        }
      };
    }
    
    // Safe implementation of showRecentlyViewed
    if (typeof window.Shopify.Products.showRecentlyViewed !== 'function') {
      window.Shopify.Products.showRecentlyViewed = function(config) {
        try {
          // Default configuration
          const defaultConfig = {
            container: '#recently-viewed-products',
            template: '#recently-viewed-product-template',
            limit: 5,
            onComplete: null
          };
          
          // Merge default config with provided config
          config = Object.assign({}, defaultConfig, config || {});
          
          // Get recently viewed products from localStorage
          let recentlyViewed = [];
          try {
            const stored = localStorage.getItem('recentlyViewed');
            if (stored) {
              recentlyViewed = JSON.parse(stored);
            }
          } catch (e) {
            console.log('Recently Viewed Products Fix: Error reading from localStorage', e);
            recentlyViewed = [];
          }
          
          // Limit the number of products to show
          recentlyViewed = recentlyViewed.slice(0, config.limit);
          
          // Find the container element
          const container = document.querySelector(config.container);
          if (!container) {
            console.log('Recently Viewed Products Fix: Container not found', config.container);
            return;
          }
          
          // Find the template element
          const template = document.querySelector(config.template);
          if (!template) {
            console.log('Recently Viewed Products Fix: Template not found', config.template);
            return;
          }
          
          // Clear the container
          container.innerHTML = '';
          
          // If no recently viewed products, hide the container
          if (recentlyViewed.length === 0) {
            container.style.display = 'none';
            return;
          }
          
          // Show the container
          container.style.display = 'block';
          
          // Render each product
          recentlyViewed.forEach(function(product) {
            // Clone the template
            const productElement = template.content.cloneNode(true);
            
            // Update the product data
            const titleElement = productElement.querySelector('.product-title');
            if (titleElement) {
              titleElement.textContent = product.title;
            }
            
            const linkElements = productElement.querySelectorAll('a');
            linkElements.forEach(function(link) {
              link.href = product.url;
            });
            
            const imageElement = productElement.querySelector('img');
            if (imageElement && product.image) {
              imageElement.src = product.image;
              imageElement.alt = product.title;
            }
            
            const priceElement = productElement.querySelector('.product-price');
            if (priceElement && product.price) {
              priceElement.textContent = product.price;
            }
            
            const vendorElement = productElement.querySelector('.product-vendor');
            if (vendorElement && product.vendor) {
              vendorElement.textContent = product.vendor;
            }
            
            // Add the product to the container
            container.appendChild(productElement);
          });
          
          // Call the onComplete callback if provided
          if (typeof config.onComplete === 'function') {
            config.onComplete();
          }
          
          console.log('Recently Viewed Products Fix: Successfully displayed products');
        } catch (e) {
          console.error('Recently Viewed Products Fix: Error in showRecentlyViewed', e);
        }
      };
    }
    
    // Automatically record the current product if we're on a product page
    if (window.location.pathname.includes('/products/')) {
      // Get product data from the page
      const productTitle = document.querySelector('.ProductMeta__Title, .Product__Title, h1')?.textContent.trim();
      const productImage = document.querySelector('.Product__Gallery img, .ProductGallery img')?.src;
      const productVendor = document.querySelector('.ProductMeta__Vendor, .Product__Vendor')?.textContent.trim();
      const productPrice = document.querySelector('.ProductMeta__Price, .Product__Price')?.textContent.trim();
      
      // Record the product
      window.Shopify.Products.recordRecentlyViewed({
        title: productTitle,
        image: productImage,
        vendor: productVendor,
        price: productPrice
      });
    }
    
    console.log('Recently Viewed Products Fix: Initialization complete');
  });
})();
